module.exports = __webpack_public_path__ + "img/tile-fnb1.71d190dd.jpg";